type Props = { variant: "expired" | "not_found" };

export function SurveyExpired({ variant }: Props) {
  const text =
    variant === "expired"
      ? "This link has expired. Text Wren for a fresh one."
      : "Hmm, this link isn't working. Text Wren for a fresh one.";
  return (
    <div className="mx-auto max-w-md px-6 py-24 text-center text-[1rem] text-[color:var(--color-wren-supporting)]">
      {text}
    </div>
  );
}
